export enum SortableOptions {
    department = 'department',
    date = 'date'
}

export type Sort = {
    sortBy: SortableOptions,
};
